var map = {
	"./c11-connect.png": 1618,
	"./c12-connect.png": 1619,
	"./c12e-connect.png": 1620,
	"./c13-connect.png": 1621,
	"./c13c-connect.png": 1622,
	"./c15-4g-connect.png": 1623,
	"./c15-connect.png": 1624,
	"./c16-connect.png": 1625,
	"./c20-connect.png": 1626,
	"./c21-connect.png": 1627,
	"./c31-connect.png": 1628,
	"./c31pro-connect.png": 1629,
	"./c50-connect.png": 1630,
	"./c52-connect.png": 1631,
	"./c71-connect.png": 1632,
	"./c80-connect.png": 1633,
	"./cmcc-v1-connect.png": 1634,
	"./cmcc-v2-connect.png": 1635,
	"./hdc-51-connect.png": 1636,
	"./hdc-55-connect.png": 1637,
	"./hdc-63-connect.png": 1638,
	"./other-connect.png": 1639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1617;